import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { getSettings } from "@/lib/api";

const DEFAULT_NUMBER = "+49 157 50 186769";
const DEFAULT_MSG = "Hallo Landingsstrategie, ich interessiere mich für eine Website.";

export default function WhatsappButton() {
  const [number, setNumber] = useState(DEFAULT_NUMBER);
  const [message, setMessage] = useState(DEFAULT_MSG);

  useEffect(() => {
    getSettings()
      .then((s) => {
        if (s?.whatsapp) setNumber(s.whatsapp);
        if (s?.whatsapp_message !== undefined) setMessage(s.whatsapp_message || "");
      })
      .catch(() => {});
  }, []);

  const digits = (number || "").replace(/\D/g, "");
  if (!digits) return null;
  const href = `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Über WhatsApp kontaktieren"
      data-testid="whatsapp-button"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.4, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 z-[55] group flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] shadow-lg shadow-black/40"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40 group-hover:opacity-0" />
      <svg viewBox="0 0 24 24" className="relative h-7 w-7 fill-white" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.887 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.358.101 11.94c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.652a11.95 11.95 0 005.71 1.454h.005c6.582 0 11.94-5.358 11.943-11.94a11.86 11.86 0 00-3.473-8.413" />
      </svg>
    </motion.a>
  );
}
